// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3doJW","head":"Table_head__xus1M","col":"Table_col__2HwHq"};